import {MouseEvent, ReactNode, useMemo} from 'react';
import ContentCardV4 from '../../../common/component/ContentCardV4';
import {DEFAULT_ASPECT_RATIO} from '../../../common/constant';
import useScreenType from '../../../common/hook/useScreenType';
import {IMyPageContentItem} from '../../../commonSub/type';

interface IProps {
  content: IMyPageContentItem;
  children: ReactNode;
  isDimmed?: boolean;
  isBig?: boolean;
  onClick?: (id: number, sid: string) => void;
  onClickBottom?: () => void;
}

export default function MyContentCardV4({
  content,
  children,
  isDimmed,
  isBig,
  onClick,
  onClickBottom,
}: IProps) {
  const {isLarge} = useScreenType();
  const {bgColor} = content;
  const contentProps = useMemo(
    () => ({
      ...content,
      thumbImg: isBig ? content.mainImg || '' : content.thumbImg,
    }),
    [content, isBig]
  );

  const handleClickCaptureBottom = (e: MouseEvent) => {
    // 기본적으로 작품홈으로 라우팅되는 것을 막는다.
    e.stopPropagation();
    onClickBottom?.();
  };

  return (
    <div className="relative overflow-hidden rounded-8">
      <ContentCardV4
        content={contentProps}
        aspectRatio={
          isBig
            ? isLarge
              ? BIG_ASPECT_RATIO_LARGE
              : BIG_ASPECT_RATIO
            : DEFAULT_ASPECT_RATIO
        }
        className={cn('!rounded-none', {
          [DIMMED_CN]: isDimmed,
        })}
        onClick={onClick}
        bgScaleClassName={cn(
          isBig ? 'scale-[1]' : 'scale-[1.35] !origin-center'
        )}
        thumbClassName={cn(isBig && 'mt-4 !h-[calc(100%-4px)]')}
        isBig={isBig}
      />
      <div
        className={cn('h-44 flex-center cursor-pointer', {
          'relative z-1': isDimmed,
        })}
        style={{
          background: `
            linear-gradient(0deg,
            rgba(0, 0, 0, 0.15),
            rgba(0, 0, 0, 0.15)),
            ${bgColor}`,
        }}
        onClickCapture={handleClickCaptureBottom}
      >
        <div
          className={cn('w-full h-full flex-center pointer-events-none', {
            'bg-black/70': isDimmed,
          })}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

const DIMMED_CN = cn(
  'before:inset-0 before:absolute before:z-1',
  'before:bg-black/70',
  'before:pointer-events-none'
);

const BIG_ASPECT_RATIO = 230 / 175;
const BIG_ASPECT_RATIO_LARGE = 298 / 302;
